import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function glAccountTickmarkReducer(state = initialstate.glAccountTickmark, action) {
	switch (action.type) {
		case types.REMOVE_TICKMARKS:
		case types.ADD_TICKMARKS: {
			if (action.response) {
				return action.response.data || state;
			}
		}
		default:
			return state;
	}
}
